import React from 'react';
import { Card } from '../../ui/Card';
import { Badge } from '../../ui/Badge';
import { useTeachers } from '../../../hooks/useTeachers';
import { formatEuro } from '../../../utils/currency';
import { teacherFullName } from '../../../utils/teachers';
import { teacherLineTotal } from '../../../utils/trainingCourses';
import { CourseTeacher } from '../../../types/trainingCourse';
interface CourseTeachersCardProps {
  teachers: CourseTeacher[];
  onOpenTeacher: (teacherId: string) => void;
}
const statusVariant = {
  'Da inviare': 'neutral',
  Inviato: 'warning',
  Confermato: 'success'
} as const;
export function CourseTeachersCard({
  teachers,
  onOpenTeacher
}: CourseTeachersCardProps) {
  const allTeachers = useTeachers();
  const total = teachers.reduce((s, t) => s + teacherLineTotal(t), 0);
  return <Card title="Docenti" noPadding noHoverShadow className="overflow-hidden" data-id="element-1164" data-mp="2z4qzy0eion5i">
      {teachers.length === 0 ? <p className="px-6 py-10 text-sm text-slate-500 text-center" data-id="element-1165" data-mp="342snoymw1anb">
          Nessun docente assegnato. Puoi aggiungerli da Modifica.
        </p> : <div className="overflow-x-auto" data-id="element-1166" data-mp="2pecnx6eyougz">
          <table className="w-full text-left text-sm" data-id="element-1167" data-mp="2pdjs30hjjpdm">
            <thead data-id="element-1168" data-mp="342pokgozv1ht">
              <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-1169" data-mp="3438z3ccbenlt">
                <th className="px-6 py-3" data-id="element-1170" data-mp="2z4o4ptjquy5a">Docente</th>
                <th className="px-4 py-3" data-id="element-1171" data-mp="2bdif4mo04rhs">Stato incarico</th>
                <th className="px-4 py-3 text-right whitespace-nowrap" data-id="element-1172" data-mp="2bg4xlhcfkres">
                  Costo orario
                </th>
                <th className="px-4 py-3 text-right" data-id="element-1173" data-mp="2keqfrbdzq4f1">Ore</th>
                <th className="px-6 py-3 text-right whitespace-nowrap" data-id="element-1174" data-mp="2kgb58mlg6x61">
                  Importo totale
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-1175" data-mp="3vt3xdyi5hnmm">
              {teachers.map(row => {
            const teacher = allTeachers.find(t => t.id === row.teacherId);
            return <tr key={row.teacherId} data-id="element-1176" data-mp="2ogur1eap28ba">
                    <td className="px-6 py-4" data-id="element-1177" data-mp="2ok0eyq7l745f">
                      {teacher ? <button type="button" onClick={() => onOpenTeacher(teacher.id)} className="font-medium text-seform-navy hover:text-seform-orange underline-offset-2 hover:underline text-left" data-id="element-1178" data-mp="2titx4vxtjjbx">
                          {teacherFullName(teacher)}
                        </button> : <span className="text-slate-500" data-id="element-1179" data-mp="2eruqvrkgh6vi">
                          {teacherFullName()}
                        </span>}
                    </td>
                    <td className="px-4 py-4" data-id="element-1180" data-mp="2jknugc46u960">
                      <Badge variant={statusVariant[row.assignmentStatus]} size="sm" data-id="element-1181" data-mp="1n1gjme6y6sst">
                        {row.assignmentStatus}
                      </Badge>
                    </td>
                    <td className="px-4 py-4 text-right tabular-nums text-slate-600 whitespace-nowrap" data-id="element-1182" data-mp="1jj9an543hc7b">
                      {formatEuro(row.hourlyRate)}
                    </td>
                    <td className="px-4 py-4 text-right tabular-nums text-slate-600" data-id="element-1183" data-mp="1ai1ccn1kwbd8">
                      {(row.hours || 0).toLocaleString('it-IT')}
                    </td>
                    <td className="px-6 py-4 text-right tabular-nums font-medium text-slate-800 whitespace-nowrap" data-id="element-1184" data-mp="15ionxxv26w8j">
                      {formatEuro(teacherLineTotal(row))}
                    </td>
                  </tr>;
          })}
            </tbody>
            <tfoot data-id="element-1185" data-mp="quvbun56mbup">
              <tr className="border-t border-slate-200" data-id="element-1186" data-mp="qubtj5bmdlg5">
                <td colSpan={4} className="px-6 py-4 text-sm text-slate-600" data-id="element-1187" data-mp="mt9rkgqbivah">
                  Importo complessivo docenza
                </td>
                <td className="px-6 py-4 text-right tabular-nums font-semibold text-seform-navy whitespace-nowrap" data-id="element-1188" data-mp="hsm4u794h0m2">
                  {formatEuro(total)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>}
    </Card>;
}